import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { apiCall } from "utils/apiClient";

const ListPrompts = () => {
    const [prompts, setPrompts] = useState([]);
    const navigate = useNavigate();

    const fetchPrompts = async () => {
        try {
            const result = await apiCall({
                endpoint: "prompts",
                method: "GET"
            });
            if (result.status === 200) {
                setPrompts(result.data);
            } else {
                toast.error("Failed to fetch prompts");
            }
        } catch (err) {
            toast.error("Something went wrong");
        }
    };

    useEffect(() => {
        fetchPrompts();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Toaster position="top-center" />
            <div className="px-6 py-5 bg-white min-h-screen">
                <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
                    <h2 className="text-lg font-bold text-gray-800">Prompt List</h2>
                    <button
                        onClick={() => navigate("/add-prompt")}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded text-sm"
                    >
                        + Add Prompt
                    </button>
                </div>

                <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
                    <div className="px-4 py-3 bg-gray-50 border-b border-gray-100 flex items-center justify-between">
                        <h4 className="text-sm font-semibold text-gray-700">Prompts</h4>
                        <span className="text-xs text-gray-500">{prompts.length} total</span>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="min-w-full text-xs">
                            <thead className="bg-white border-b">
                            <tr>
                                <th className="text-left px-3 py-2">Sr No</th>
                                <th className="text-left px-3 py-2">Prompt</th>
                                <th className="text-left px-3 py-2">Style</th>
                                <th className="text-left px-3 py-2">Image</th>
                                <th className="text-left px-3 py-2">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                                {prompts.map((prompt, i) => (
                                    <tr key={prompt.id} className="border-t hover:bg-gray-50">
                                        <td className="px-3 py-2">{i + 1}</td>
                                        <td className="px-3 py-2 max-w-[420px] truncate" title={prompt.prompt}>
                                            {prompt.prompt}
                                        </td>
                                        <td className="px-3 py-2">{prompt.style_name || "-"}</td>
                                        <td className="px-3 py-2">
                                            {prompt.image_path ? (
                                                <img
                                                    src={process.env.REACT_APP_HAPS_MAIN_BASE_URL + prompt.image_path}
                                                    alt="Prompt"
                                                    className="w-12 h-12 object-cover rounded border border-gray-200"
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td className="px-3 py-2">
                                            <button
                                                onClick={() => navigate("/edit-prompt", { state: { id: prompt.id } })}
                                                className="text-blue-600 hover:text-blue-700 text-xs font-medium"
                                            >
                                                Edit
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {prompts.length === 0 && (
                                    <tr>
                                        <td colSpan={5} className="text-center py-5 text-gray-500">
                                            No prompts found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default ListPrompts;
